import React, { useState } from "react";
import { Box, HStack, Switch, Text, Tooltip } from "@chakra-ui/react";
import Table1 from "./components/Table1";
import Exports from "./components/Exports";
import PageToolbar from "../../components/shared/PageToolbar";
import { Panel } from "../../components/shared/Section";
import { useSupplierRetailer } from "../../wrappers/SupplierRetailerContext";
import { neutral, type } from "../../theme/tokens";

// The choice is remembered per browser: a buyer who works without the
// discontinued lines does so every time they open the page.
const STORAGE_KEY = "spearbi_ranging_hide_discontinued";

const Ranging = () => {
  const { selectedRetailer, selectedSupplier } = useSupplierRetailer();
  const [hideDiscontinued, setHideDiscontinued] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "true";
    } catch (e) {
      return false;
    }
  });
  // Reported up by the table once it knows the article list, so the label can
  // say how many columns the switch is holding back.
  const [discontinuedCount, setDiscontinuedCount] = useState(0);

  const handleToggle = (e) => {
    const next = e.target.checked;
    setHideDiscontinued(next);
    try {
      localStorage.setItem(STORAGE_KEY, String(next));
    } catch (err) {
      /* private mode — the toggle still works for this session */
    }
  };

  return (
    <Box>
      {/* Title and the supplier/retailer context now live in the command bar,
          so this strip carries only what belongs to the page. */}
      <PageToolbar
        description="Which articles are ranged in which stores"
        filters={
          <Tooltip label="Articles whose brand or description carries a 'disc' marker" openDelay={400} fontSize="xs">
            <HStack spacing={2}>
              <Switch id="ranging-hide-discontinued" size="sm" colorScheme="brand" isChecked={hideDiscontinued} onChange={handleToggle} />
              <Text as="label" htmlFor="ranging-hide-discontinued" fontSize={type.size.small} color={neutral[600]} cursor="pointer" userSelect="none" whiteSpace="nowrap">
                Hide discontinued
                {discontinuedCount > 0 && (
                  <Text as="span" color={neutral[400]} ml={1}>
                    ({discontinuedCount})
                  </Text>
                )}
              </Text>
            </HStack>
          </Tooltip>
        }
        actions={<Exports supplier={selectedSupplier} retailer={selectedRetailer} hideDiscontinued={hideDiscontinued} />}
      />

      <Panel padded={false}>
        {/* The table owns its own scrolling — it is the scroll container the
            frozen header sticks to, so this wrapper must not scroll as well. */}
        <Box id="ranging-wrapper">
          <Table1 supplier={selectedSupplier} retailer={selectedRetailer} hideDiscontinued={hideDiscontinued} onDiscontinuedCount={setDiscontinuedCount} />
        </Box>
      </Panel>
    </Box>
  );
};

export default Ranging;
